type CHECK_MARK_CIRCLE_PROPS = {
  width?: number;
  height?: number;
  opacity?: number;
  circleFill?: string;
  tickColor?: string;
};

export const CheckMarkCircle = ({
  width = 25,
  height = 25,
  opacity = 1,
  circleFill = '#1572ED',
  tickColor = '#1572ED',
}: CHECK_MARK_CIRCLE_PROPS): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={opacity}
        d="M21.0547 12.9531C21.0547 14.7332 20.5268 16.4732 19.5379 17.9533C18.549 19.4333 17.1434 20.5869 15.4988 21.268C13.8543 21.9492 12.0447 22.1275 10.2989 21.7802C8.55305 21.4329 6.9494 20.5758 5.69073 19.3171C4.43206 18.0584 3.57489 16.4548 3.22762 14.7089C2.88036 12.9631 3.05859 11.1535 3.73978 9.50897C4.42096 7.86444 5.57452 6.45883 7.05456 5.4699C8.5346 4.48097 10.2747 3.95313 12.0547 3.95312C14.4416 3.95313 16.7308 4.90134 18.4187 6.58916C20.1065 8.27699 21.0547 10.5662 21.0547 12.9531Z"
        fill={circleFill}
      />
      <path
        d="M16.3353 10.1725C16.405 10.2422 16.4604 10.3249 16.4981 10.4159C16.5359 10.507 16.5553 10.6046 16.5553 10.7031C16.5553 10.8017 16.5359 10.8993 16.4981 10.9903C16.4604 11.0814 16.405 11.1641 16.3353 11.2338L11.0853 16.4838C11.0157 16.5535 10.9329 16.6088 10.8419 16.6465C10.7508 16.6843 10.6533 16.7037 10.5547 16.7037C10.4561 16.7037 10.3585 16.6843 10.2675 16.6465C10.1764 16.6088 10.0937 16.5535 10.0241 16.4838L7.77407 14.2338C7.63334 14.093 7.55427 13.9021 7.55427 13.7031C7.55428 13.5041 7.63334 13.3132 7.77407 13.1725C7.9148 13.0318 8.10567 12.9527 8.30469 12.9527C8.50371 12.9527 8.69459 13.0318 8.83532 13.1725L10.5547 14.8928L15.2741 10.1725C15.3437 10.1028 15.4264 10.0474 15.5175 10.0097C15.6085 9.97196 15.7061 9.95253 15.8047 9.95253C15.9033 9.95253 16.0008 9.97196 16.0919 10.0097C16.1829 10.0474 16.2657 10.1028 16.3353 10.1725ZM21.8047 12.9531C21.8047 14.8815 21.2329 16.7666 20.1615 18.3699C19.0902 19.9733 17.5674 21.223 15.7859 21.9609C14.0043 22.6989 12.0439 22.892 10.1526 22.5158C8.26125 22.1396 6.52396 21.211 5.1604 19.8474C3.79684 18.4839 2.86824 16.7466 2.49204 14.8553C2.11583 12.9639 2.30891 11.0035 3.04687 9.22196C3.78482 7.44038 5.0345 5.91764 6.63788 4.8463C8.24126 3.77495 10.1263 3.20313 12.0547 3.20312C14.6397 3.20585 17.1181 4.23396 18.946 6.06185C20.7739 7.88974 21.802 10.3681 21.8047 12.9531ZM20.3047 12.9531C20.3047 11.3214 19.8208 9.72638 18.9143 8.36967C18.0078 7.01296 16.7193 5.95554 15.2118 5.33112C13.7043 4.7067 12.0455 4.54332 10.4452 4.86165C8.84485 5.17997 7.37484 5.96571 6.22106 7.11949C5.06728 8.27328 4.28154 9.74329 3.96321 11.3436C3.64489 12.944 3.80826 14.6028 4.43269 16.1103C5.05711 17.6178 6.11453 18.9062 7.47124 19.8127C8.82794 20.7193 10.423 21.2031 12.0547 21.2031C14.242 21.2006 16.3389 20.3307 17.8856 18.784C19.4322 17.2374 20.3022 15.1404 20.3047 12.9531Z"
        fill={tickColor}
      />
    </svg>
  );
};
